var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRssSquareFilled = function SvgRssSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    fillRule: "evenodd",
    d: "M7.304 1.333h1.392c.909 0 1.631 0 2.214.048.597.049 1.106.15 1.573.388a4 4 0 0 1 1.748 1.748c.237.467.34.976.388 1.573.048.583.048 1.305.048 2.214v1.392c0 .909 0 1.631-.048 2.214-.049.597-.15 1.107-.388 1.573a4 4 0 0 1-1.748 1.748c-.467.237-.976.34-1.573.388-.583.048-1.305.048-2.214.048H7.304c-.909 0-1.631 0-2.214-.048-.597-.049-1.106-.15-1.573-.388a4 4 0 0 1-1.748-1.748c-.237-.466-.34-.976-.388-1.573-.048-.583-.048-1.305-.048-2.214V7.304c0-.909 0-1.631.048-2.214.049-.597.15-1.106.388-1.573A4 4 0 0 1 3.517 1.77c.467-.237.976-.34 1.573-.388.583-.048 1.305-.048 2.214-.048ZM4.667 4a.667.667 0 0 0 0 1.333 6 6 0 0 1 6 6 .667.667 0 0 0 1.333 0A7.333 7.333 0 0 0 4.667 4Zm0 3.158a.667.667 0 1 0 0 1.333 2.842 2.842 0 0 1 2.842 2.842.667.667 0 0 0 1.333 0 4.175 4.175 0 0 0-4.175-4.175Zm.17 3.333a.667.667 0 1 0 0 1.334h.005a.667.667 0 0 0 0-1.334h-.005Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRssSquareFilled);
export default ForwardRef;